import { graphql } from 'react-relay';
import { useQueryInterop } from '@confluence/apollo-relay-interop';

import type {
	useContentPermissionsQuery$data as QueryData,
	useContentPermissionsQuery$variables as QueryVariables,
} from './__generated__/useContentPermissionsQuery.graphql.ts';

export const contentPermissionsQuery = graphql`
	query useContentPermissionsQuery($cloudId: ID!, $contentId: ID!) {
		confluence_contentPermissions(cloudId: $cloudId, contentId: $contentId) {
			confluencePermissionsSummary {
				limit
				remainingSlots
				totalCount
				totalGroups
				totalTeams
				totalUsers
				__typename
			}
			confluencePrincipalsConnection {
				nodes {
					avatar
					displayName
					effectivePermission
					explicitPermission
					hasSpaceEditPermission
					hasSpaceViewPermission
					principalId
					principalType
					restrictingContent {
						id
						links {
							base
							webui
						}
					}
					sitePermissionType
					usageType
				}
				pageInfo {
					endCursor
					hasNextPage
				}
				__typename
			}
			contentId
			generalAccess {
				mode
			}
		}
	}
`;

export function useContentPermissions(variables: QueryVariables, options?: { skip?: boolean }) {
	return useQueryInterop<QueryData, QueryVariables>(contentPermissionsQuery, {
		variables,
		skip: options?.skip,
		fetchPolicy: 'network-only',
	});
}
